import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import Reports from "../Reports";
import InvoiceForAllMembers from "../CreateInvoiceForAllMembers";

function AdminInvoiceCreateAll(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={8}
        childrenPage={<InvoiceForAllMembers/>}/>
        </DataContext.Provider>
    )
}

export default AdminInvoiceCreateAll;